import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  loginRequest,
  loginSuccess,
  loginFailure,
  fetchSessionRequest,
  fetchSessionSuccess,
  fetchSessionFailure,
  logout,
  registerSuccess,
  registerFailure,
  registerRequest,
} from "./userActions";
import userService, {
  RegisterPayload,
} from "../../../services/api.services/user/userService";
import { NormalizedError } from "services/axios.services/http/interceptors/commonInterceptors";
// import SessionManager from "../../../services/auth/sessionManager";

// Worker Saga: handle login
function* handleLogin(
  action: ReturnType<typeof loginRequest>
): Generator<any, void, any> {
  try {
    const data = yield call(userService.login, action.payload);
    // console.log("saga-----data  ", data);

    if (!data?.token) {
      yield put(loginFailure("Login failed"));
    } else {
      // yield put(fetchSessionRequest());
      yield put(loginSuccess(data));
    }
    // yield put(loginSuccess(data));
  } catch (error: any) {
    // console.log({error});

    const err = error as NormalizedError;

    // console.log({err});

    // Friendly UI message
    let uiMsg = "Login failed";
    if (err?.isNetwork)
      uiMsg = "Internal server error. Please try again after some time.";
    // else if (err.isTimeout) uiMsg = "server took too long to respond. Please try again.";
    else if (err?.status === 401) uiMsg = "Invalid credentials.";
    else if (err?.status >= 500) uiMsg = "Server error. Please try again.";

    yield put(loginFailure(uiMsg));
    // yield put(loginFailure(error.message || "Login failed"));
  }
}

// Register saga
function* handleRegister(
  action: ReturnType<typeof registerRequest>
): Generator<any, void, any> {
  try {
    const payload: RegisterPayload = action.payload;

    const data = yield call(userService.register, payload);

    if(!data.status || data.statusCode === "409"){
      yield put(registerFailure(data.message));
      return;
    }

    yield put(registerSuccess(data));

  } catch (error: any) {
    const err = error as NormalizedError;

    // console.log({err});
    
     let uiMsg = err?.raw?.message || "Registration failed";
    if (err?.isNetwork)
      uiMsg = "Internal server error. Please try again after some time.";
    else if (err?.status === 400)
      uiMsg = err?.message || "Invalid details. Please check your inputs.";
    else if (err?.status === 409)
      uiMsg = err?.message || "User already exists.";
    else if (err?.status >= 500) uiMsg = "Server error. Please try again.";

    yield put(registerFailure(uiMsg));
  }
}

// Worker Saga: fetch session
function* handleFetchSession(): Generator<any, void, any> {
  try {
    const data = yield call(userService.fetchSession);
    yield put(fetchSessionSuccess(data));
  } catch (error: any) {
    yield put(fetchSessionFailure(error.message || "Session fetch failed"));
    // yield put(logout());
  }
}

// Worker Saga: logout
function* handleLogout(): Generator<any, void, any> {
  try {
    yield call(userService.logout);
  } catch {
    // ignore errors on logout
  }
}

// function* authInit() {
//   try {
//     if (SessionManager.getAccessToken()) {
//       yield put(fetchSessionRequest());
//     }
//   } catch (err) {
//     console.error("_Init", err);
//   }
// }

export default function* userSaga() {
  yield all([
    // fork(authInit),
    takeLatest(loginRequest.type, handleLogin),
    takeLatest(fetchSessionRequest.type, handleFetchSession),
    takeLatest(logout.type, handleLogout),
    takeLatest(registerRequest.type, handleRegister),
  ]);
}

// export default function* userSaga() {
//   yield takeLatest(loginRequest.type, handleLogin);
//   yield takeLatest(fetchSessionRequest.type, handleFetchSession);
//   yield takeLatest(logout.type, handleLogout);
// }
